<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="characterjob-with-description">
<h1><strong>Character/Job with Description</strong></h1>
<div class="section level2" id="zebra-ice-through-axiton-andromeda">
<h2>Z<strong>ebra-Ice through Axiton, Andromeda</strong></h2>
<br/><br/><br/>
<table style="width: 99%; text-align: left;">
<colgroup>
<col width="33%"/>
<col width="65%"/>
</colgroup>
<thead>
<tr class="header">
<th style="border-right:none !important;">Character</th>
<th style="border-left:none !important;">Job with Description</th>
</tr>
</thead>
<tbody>
<tr class="odd">
<td>Alan Baxter</td>
<td><p>Alan Baxter</p>
<p>A pterodactyl lead scientist</p></td>
</tr>
<tr class="even">
<td>Anastazia Roxeski</td>
<td><p>Anastazia Roxeski</p>
<p>A five-star Lepi-Spot Ukrainian General serving as the Ukrainian Ambassador to du Plessis with an intergalactic war-charter manifest</p></td>
</tr>
<tr class="odd">
<td>Ukrainian Senator Volodymyr Kovalevsky</td>
<td><p>Lepi-Spot Ukrainian Senator Volodymyr Kovalevsky</p>
<p>A short and stocky hot tempered Lepi-Spot Ukrainian Senator Volodymyr Kovalevsky</p></td>
</tr>
<tr class="even">
<td>Ukrainian special agent Natalia Kolesnikov</td>
<td><p>Ukrainian special agent Natalia Kolesnikov</p>
<p>A Ukrainian Lepi-Spot special agent Natalia Kolesnikov</p></td>
</tr>
<tr class="odd">
<td>Margaretta du Plessis</td>
<td><p>Madam Prime Minister</p>
<p>A short and fiery hot-tempered blonde with an intergalactic war-charter manifest</p></td>
</tr>
<tr class="even">
<td>Her Majesty Queen Belena Kozlowski</td>
<td>Euro-Intergalactic Queen Belena Kozlowski</td>
</tr>
<tr class="odd">
<td>Craig Kawasaki-kiva</td>
<td><p>Pterodactyl, and Democratic Leader of the Opposition</p>
<p>A five-foot silver-coloured socialist pterodactyl with a real hot temper who’s eager to run the galaxy</p></td>
</tr>
<tr class="even">
<td>Prime Minister Gavin Axon</td>
<td>Byxin Prime Minister Gavin Axon</td>
</tr>
<tr class="odd">
<td>Ben Banks</td>
<td><p>Saxon Speaker of the House</p>
<p>A six-foot tall liberal martial-arts and bodybuilder with light-brown hair and olive-green eyes, who wants everyone to know everyone’s business</p></td>
</tr>
<tr class="even">
<td>Randy Gibson</td>
<td><p>Intergalactic Network News</p>
<p>A short liberal redhead with an intergalactic agenda</p></td>
</tr>
<tr class="odd">
<td>Alexandria Warberg</td>
<td><p>Lepi-Spot and Leader of the Liberals</p>
<p>A short fiery and war-mongering yellow skinned leopard being with two thousand indigo spots on her body who speaks twenty-seven Euro languages</p></td>
</tr>
<tr class="even">
<td>Aeon Gilbert</td>
<td><p>Lepi-Spot Intergalactic Warrior Intelligence Officer</p>
<p>A warrior intelligence officer and war-mongering yellow skinned leopard being with two thousand indigo spots on his body who speaks twenty-seven Euro languages</p></td>
</tr>
<tr class="odd">
<td>Beth Rixon</td>
<td><p>Intergalactic Lepi-Spot Intelligence Chief</p>
<p>A warrior intelligence chief and war-mongering yellow skinned leopard being with two thousand indigo spots on his body who speaks twenty-seven Euro languages</p></td>
</tr>
<tr class="even">
<td>Gavin Axon</td>
<td>Byxin’s Prime Minister Gavin Axon of Andromeda</td>
</tr>
<tr class="odd">
<td>Anita Fire-Burger</td>
<td>SASA Receptionist</td>
</tr>
<tr class="even">
<td>Ely O’Grady</td>
<td><p>Robotics &amp; Space-age Expert</p>
<p>A space-age technologies expert and an electronics specialist in flying-cars including robotics</p></td>
</tr>
<tr class="odd">
<td>Paulo dos Santos</td>
<td>SASA Androids Production Lead</td>
</tr>
<tr class="even">
<td>Rupert du Plessis</td>
<td><p>Couturier</p>
<p>A short and stocky platinum blonde fashion couturier</p></td>
</tr>
<tr class="odd">
<td>President Paulo de Oliveira</td>
<td>Brazilian President Paulo de Oliveira</td>
</tr>
<tr class="even">
<td>Alice Rankle</td>
<td>Pterodactyl and Democratic Leader of the Opposition Alice Rankle</td>
</tr>
<tr class="odd">
<td>Supreme Court Judge Andria Spikes</td>
<td>Supreme Court Judge Andria Spikes</td>
</tr>
<tr class="even">
<td>Congressman (D) Paul Spikes</td>
<td>Democratic Congressman for Virginia</td>
</tr>
<tr class="odd">
<td>Senator (R) Alexi Novinsky</td>
<td>Republican State Senator Alexi Novinsky</td>
</tr>
<tr class="even">
<td>Wendy Spikes</td>
<td>Paul Spikes’ wife</td>
</tr>
<tr class="odd">
<td>US Republican President Swartz</td>
<td>US Republican President Swartz</td>
</tr>
<tr class="even">
<td>Bettie Spikes</td>
<td>Miami TV CEO and owner</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3345882a